import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import NeonMic from "@/components/NeonMic";
import { Reveal, FadeIn } from "@/components/Reveal";

const VIBE = [
    "Real conversations",
    "Good energy",
    "Community focused",
    "Authentic · unfiltered",
    "Fun, safe & respectful space",
];

export default function Interviews() {
    return (
        <>
            <PageHeader
                eyebrow="In-depth conversations"
                title="Interviews"
                description="A collection of conversations with artists, entrepreneurs, businesses, nonprofits, and community leaders across the Twin Cities."
            />

            <section className="pb-24 sm:pb-32">
                <div className="mx-auto max-w-7xl px-5 sm:px-8">
                    <Reveal>
                        <div
                            data-testid="interviews-coming-soon-card"
                            className="grain relative overflow-hidden border border-white/10 bg-coal/60 px-6 py-16 text-center sm:px-12 sm:py-24"
                        >
                            <div
                                className="absolute inset-0"
                                style={{
                                    background:
                                        "radial-gradient(480px 300px at 50% 30%, rgba(255,0,127,0.12), transparent 65%)",
                                }}
                            />
                            <div className="relative z-10 mx-auto max-w-2xl">
                                <FadeIn delay={0.1}>
                                    <NeonMic className="mx-auto w-28 opacity-90 sm:w-32" />
                                </FadeIn>
                                <FadeIn delay={0.25}>
                                    <p className="mt-6 font-script text-4xl text-neon-pink neon-pink-text animate-flicker sm:text-5xl">
                                        the mic is warming up...
                                    </p>
                                </FadeIn>
                                <FadeIn delay={0.35}>
                                    <h2 className="mt-6 font-display text-2xl font-bold uppercase sm:text-4xl">
                                        First conversations are being
                                        scheduled, recorded, and edited
                                    </h2>
                                </FadeIn>
                                <FadeIn delay={0.45}>
                                    <p className="mt-5 text-fog sm:text-lg">
                                        Check back soon — or better yet, tell us
                                        whose story we should tell next.
                                        Recommendations roll straight to
                                        Courtnie's inbox.
                                    </p>
                                </FadeIn>
                                <FadeIn delay={0.55}>
                                    <div className="mt-9 flex flex-wrap justify-center gap-4">
                                        <Link
                                            to="/contact?type=Interview%20request"
                                            data-testid="interviews-request-btn"
                                            className="group flex items-center gap-2 rounded-full bg-neon-pink px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] text-ink transition-all hover:neon-box-pink"
                                        >
                                            Request an interview
                                            <ArrowRight
                                                size={15}
                                                className="transition-transform group-hover:translate-x-1"
                                            />
                                        </Link>
                                        <Link
                                            to="/contact?type=Story%20idea"
                                            data-testid="interviews-story-btn"
                                            className="rounded-full border border-white/20 px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] text-silver transition-all hover:border-neon-pink hover:text-neon-pink"
                                        >
                                            Submit a story idea
                                        </Link>
                                    </div>
                                </FadeIn>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>

            <section className="border-t border-white/10 bg-coal/40 py-16">
                <div className="mx-auto max-w-7xl px-5 sm:px-8">
                    <Reveal>
                        <p className="eyebrow">Every episode, the same vibe</p>
                        <ul className="mt-8 grid gap-px overflow-hidden border border-white/10 sm:grid-cols-5" data-testid="interviews-vibe-strip">
                            {VIBE.map((v) => (
                                <li
                                    key={v}
                                    className="flex items-center justify-center bg-ink px-4 py-8 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-silver transition-colors hover:text-neon-pink"
                                >
                                    {v}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
